import React from "react";
import { createPortal } from "react-dom";
import Close from "@mui/icons-material/Close";

const ADD_ORIGIN_TOUR_SPOTLIGHT_PADDING = 6;
const SHOW_ADD_ORIGIN_TOUR_CALLOUT = true;

interface AddOriginTourOverlayProps {
  spotlightRect: DOMRect;
  onDismiss: () => void;
}

export const AddOriginTourOverlay: React.FC<AddOriginTourOverlayProps> = ({
  spotlightRect,
  onDismiss,
}) => {
  const handleDismissKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter" || event.key === " ") {
      onDismiss();
    }
  };

  return createPortal(
    <div className="dom-feature-tour-overlay" role="presentation">
      <div
        className="dom-feature-tour-backdrop-segment dom-feature-tour-backdrop-segment--top"
        style={{
          height: Math.max(
            0,
            spotlightRect.top - ADD_ORIGIN_TOUR_SPOTLIGHT_PADDING,
          ),
        }}
        role="button"
        tabIndex={0}
        aria-label="Dismiss tour"
        onClick={onDismiss}
        onKeyDown={handleDismissKeyDown}
      />
      <div
        className="dom-feature-tour-backdrop-segment dom-feature-tour-backdrop-segment--bottom"
        style={{
          top: spotlightRect.bottom + ADD_ORIGIN_TOUR_SPOTLIGHT_PADDING,
        }}
        role="button"
        tabIndex={0}
        aria-label="Dismiss tour"
        onClick={onDismiss}
        onKeyDown={handleDismissKeyDown}
      />
      <div
        className="dom-feature-tour-backdrop-segment dom-feature-tour-backdrop-segment--left"
        style={{
          top: spotlightRect.top - ADD_ORIGIN_TOUR_SPOTLIGHT_PADDING,
          height: spotlightRect.height + ADD_ORIGIN_TOUR_SPOTLIGHT_PADDING * 2,
          width: Math.max(
            0,
            spotlightRect.left - ADD_ORIGIN_TOUR_SPOTLIGHT_PADDING,
          ),
        }}
        role="button"
        tabIndex={0}
        aria-label="Dismiss tour"
        onClick={onDismiss}
        onKeyDown={handleDismissKeyDown}
      />
      <div
        className="dom-feature-tour-backdrop-segment dom-feature-tour-backdrop-segment--right"
        style={{
          top: spotlightRect.top - ADD_ORIGIN_TOUR_SPOTLIGHT_PADDING,
          left: spotlightRect.right + ADD_ORIGIN_TOUR_SPOTLIGHT_PADDING,
          height: spotlightRect.height + ADD_ORIGIN_TOUR_SPOTLIGHT_PADDING * 2,
        }}
        role="button"
        tabIndex={0}
        aria-label="Dismiss tour"
        onClick={onDismiss}
        onKeyDown={handleDismissKeyDown}
      />
      {SHOW_ADD_ORIGIN_TOUR_CALLOUT && (
        <div
          id="add-origin-tour-callout"
          className="dom-feature-tour-callout"
          style={{
            top: spotlightRect.bottom + ADD_ORIGIN_TOUR_SPOTLIGHT_PADDING + 12,
            left: Math.max(12, spotlightRect.right - 280),
          }}
          role="dialog"
          aria-label="Add Origin feature tour"
        >
          <button
            type="button"
            className="dom-feature-tour-close-btn"
            aria-label="Close tour"
            onClick={onDismiss}
          >
            <Close fontSize="small" />
          </button>
        
          <p className="dom-feature-tour-body">
            Click &ldquo;Add Origin&rdquo; to add a Koch or Competitor Origin.
          </p>
        </div>
      )}
    </div>,
    document.body,
  );
};
